import * as React from "react";


export default class Header extends React.Component<{}, {}> {

    public render() {
        return (
            <div className="portal-header">
                <div className="portal-header-background">
                    <a className="header-logo-link" id="goToAllianzHomePage" href="https://www.allianz.co.uk" target="_blank" aria-label="Link to Allianz home page" />
                </div>
            </div>
        )
    }
}
